module.exports = __webpack_public_path__ + "img/1.e0d437ba.jpg";